import { TotemButtonStruct } from "./totem-button.struct";

export class TotemStruct {
    public idTotem: number | null = null;
    public idHealthUnit: number | null = null;

    public totemName: string = '';
    public printerName: string = '';
    public description: string = '';
    public pin: string = '';
    public totemUrl: string = '';
    public colorCode: string = '';
    public logoString64: string = '';

    public isActive: boolean = false;
    public useQrCode: boolean = false;
    public useFacialBiometrics: boolean = false;
    public useColor: boolean = false;
    public isLogoUploaded: boolean = false;

    public listTotemButton: TotemButtonStruct[] = [];
}